// extracted by mini-css-extract-plugin
export var categoryLinks = "GenericSideNav-module--category-links--c5a7a";
export var iconWrapper = "GenericSideNav-module--icon-wrapper--5fa82";
export var selected = "GenericSideNav-module--selected--2de80";
export var sideNavWrapper = "GenericSideNav-module--side-nav-wrapper--a947d";